import { BREAK_POINTS } from './settings';
import addARIACurrent from './module/addARIACurrent';
import {fadeToggle} from './module/fade';
import {slideToggle} from './module/slide';
import scroll2AddClass from './module/scroll2AddClass';
import gnavToggle from './module/gnavToggle';
import {langNavToggle} from './module/langNavToggle';
import {MyTab} from './module/MyTab.js';
import accordion from './module/accordion.js';
(function () {

  window.addEventListener('DOMContentLoaded', function(e) {
    addARIACurrent();
    slideToggle();
    scroll2AddClass();
		accordion();

		const tab = new MyTab('js-tab');
		if(tab) {
			const element = tab.element();
		}

		const searchModal = this.document.getElementById('js-search-modal');
    const searchToggleBtns = document.querySelectorAll('.js-search-toggle');
    [].forEach.call(searchToggleBtns, function (searchToggleBtn) {
			searchToggleBtn.addEventListener('click',function(e) {
				e.preventDefault();
				if(searchModal.classList.contains('is-show')) {
					searchModal.classList.remove('is-show');
				} else {
					searchModal.classList.add('is-show');
				}
			});
		});

    const unitEl = document.querySelectorAll('.js-fade-unit');
    [].forEach.call(unitEl, function (el) {
      const btn = el.querySelector('.js-fade-switch')
      const elTarget = el.querySelector('.js-fade-target');
      btn.addEventListener('click', function(e) {
        fadeToggle(e.currentTarget, elTarget);
      })
    });

		const sunitEl = document.querySelectorAll('.js-slide-unit');

		[].forEach.call(sunitEl, function (el) {
			const sbtn = el.querySelector('.js-slide-switch')
			const selTarget = el.querySelector('.js-slide-target');
			sbtn.addEventListener('click', function(e) {
				slideToggle(el.currentTarget, selTarget);
			});
		});

		if ( window.innerWidth < BREAK_POINTS.gtTAB) {
			const spunitEl = document.querySelectorAll('.js-sp-slide-unit');

			[].forEach.call(spunitEl, function (el) {
				const sbtn = el.querySelector('.js-sp-slide-switch')
				const selTarget = el.querySelector('.js-sp-slide-target');
				sbtn.addEventListener('click', function(e) {
					e.preventDefault();
					e.currentTarget.querySelector('.p-icon-toggle').classList.toggle('is');
					slideToggle(el.currentTarget, selTarget);
				});
			});
		}

  });

	const header = document.querySelector('.l-header');

  window.addEventListener('scroll', function(e) {
		var scTop = window.pageYOffset || document.documentElement.scrollTop;
		if(scTop > 100) {
			header.classList.add('is-scrolled');
		} else {
			header.classList.remove('is-scrolled');
		}
  });

	gnavToggle();
	langNavToggle();

})();
